// extracted by mini-css-extract-plugin
export default {"table":"DetailTable_table__zEhJd","wrapper":"DetailTable_wrapper__ppXh4","margins":"DetailTable_margins__MKHj5"};